

import Accounts from "./Accounts";


class Media extends Accounts{
    constructor(params) {
        super(params);
    
    this.accountLabel = "Media";
    this.accountType = "Media";
    this.account = "Media";
    this.Dashboard = [];
    this.isParent = true;
    this.networkConnections = {};
    this.configuration = {};
  this.setParameters(params);
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }
   
   setId(val){
    this.id = val;
    this.generic.id = val;
   }
   setUrl(val){
    this.url = val;
    this.img = val;
    this.generic.img = val;
   }
}

export default Media;
  